/* globals sift */
// TODO: this and the component use same name, although this uses list.html >_<
angular.module('zc.zenclerkS')
  .controller('ZcsCampaignsListController', ZcsCampaignsListController);

ZcsCampaignsListController.$inject = ['Campaign', 'Devise', 'ProjectExcludeIp', 'ZcsIncentive', 'ZcsOemService', 'project'];
function ZcsCampaignsListController(Campaign, Devise, ProjectExcludeIp, ZcsIncentive, ZcsOemService, project) {
  const vm = this;

  vm.ZcsOemService = ZcsOemService;
  vm.project = project;
  vm.hasActiveCampaigns = true;
  vm.activeFilters = Campaign.activeFilters();
  vm.incompleteFilters = Campaign.incompleteFilters();
  vm.excludeIps = null;
  vm.isActiveProject = vm.project.terminated_at === null;
  vm.isOemProject = vm.project.is_oem;
  vm.isMaster = Devise.isMaster();

  vm.$onInit = () => {
    ProjectExcludeIp.all(vm.project.id)
      .then(excludeIps => {
        vm.excludeIps = excludeIps;
      });
  };

  Campaign.all({projectId: vm.project.id})
    .then(res => {
      let activeCampaigns = sift(vm.activeFilters, res);
      let incompleteCampaigns = sift(vm.incompleteFilters, res);
      vm.incompleteCampaigns = incompleteCampaigns;

      vm.hasActiveCampaigns = activeCampaigns.length > 0 ||
      incompleteCampaigns.length > 0;
    });
  ZcsIncentive.all(vm.project.id).then(res => {
    vm.incentives = res;
  });

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/list/campaigns_list.controller.js